angular.module('tgaAdmin').directive('bannerAdjust', [
  '$window',
  '$rootScope',
  '$timeout',
  function ($window, $rootScope, $timeout) {
    return {
      restrict: 'A',
      link(scope, element, attrs) {
        function checkBannerHeight() {
          const el = angular.element('.app-header');
          const offset = parseInt(attrs.baOffset, 10) || 0;
          const attr = attrs.baAttr || 'paddingTop';
          const target = attrs.baTarget ? angular.element(element[0]).children(attrs.baTarget) : element;
          if (el.length && target.length) {
            const style = target[0].style[attr];
            const newStyle = `${el.height() + offset}px`;
            if (style !== newStyle) {
              target[0].style[attr] = newStyle;
            }
          }
        }
        $window.addEventListener('resize', checkBannerHeight);
        element.on('$destroy', () => {
          $window.removeEventListener('resize', checkBannerHeight);
        });
        scope.$watch(
          () => $rootScope.cache?.banners,
          () => {
            $timeout(() => {
              checkBannerHeight();
            });
          },
          true,
        );
        $timeout(() => {
          checkBannerHeight();
        });
      },
    };
  },
]);
